import { editXuserChannel } from '@/service/vbef'
import store from '@/store'
const state = store.state
const SHARECHANNEL_STORAGE_KEY = 'sharechannel'

const normalizeShareChannelId = (value) => {
  const channelId = Number(value)
  return Number.isFinite(channelId) && channelId > 0 ? channelId : 0
}

const getLocalShareChannelId = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) return 0
  try {
    return normalizeShareChannelId(window.sessionStorage.getItem(SHARECHANNEL_STORAGE_KEY))
  } catch (e) {
    return 0
  }
}

const setLocalShareChannelId = (value) => {
  if (typeof window === 'undefined' || !window.sessionStorage) return
  try {
    const channelId = normalizeShareChannelId(value)
    if (!channelId) return
    window.sessionStorage.setItem(SHARECHANNEL_STORAGE_KEY, String(channelId))
  } catch (e) {}
}

const editXuserChannelByShareChannelId = (actId, channelId) => {
  const normalizedChannelId = normalizeShareChannelId(channelId)
  if (!normalizedChannelId) return Promise.resolve(null)
  return editXuserChannel({
    actId,
    channelId: state.language == 'zh' && normalizedChannelId == 203 ? 204 : normalizedChannelId,
  })
}

const editXuserChannelByLocalShareChannelId = (actId) => {
  return editXuserChannelByShareChannelId(actId, getLocalShareChannelId())
}

export {
  getLocalShareChannelId,
  setLocalShareChannelId,
  editXuserChannelByShareChannelId,
  editXuserChannelByLocalShareChannelId,
}
